module.exports = function() {
  return new Worker(__webpack_public_path__ + "2d7bf20ae524f1ba537f.worker.js");
};